import { type ToastType } from '@/components/common/toast/toast-provider'

// Global toast instance - will be initialized by ToastProvider
let globalToastInstance: {
  showToast: (message: string, type?: ToastType) => void
  hideToast: (id: string) => void
  clearAll: () => void
} | null = null

export const setGlobalToastInstance = (instance: typeof globalToastInstance) => {
  globalToastInstance = instance
}

// API that matches react-hot-toast interface
export const toast = {
  success: (message: string) => {
    globalToastInstance?.showToast(message, 'success')
  },
  error: (message: string) => {
    globalToastInstance?.showToast(message, 'error')
  },
  warning: (message: string) => {
    globalToastInstance?.showToast(message, 'warning')
  },
  info: (message: string) => {
    globalToastInstance?.showToast(message, 'info')
  },
  dismiss: (id?: string) => {
    if (id) {
      globalToastInstance?.hideToast(id)
    } else {
      globalToastInstance?.clearAll()
    }
  },
  loading: (message: string) => {
    globalToastInstance?.showToast(message, 'info')
    return 'loading-toast-id' // Return a dummy ID for compatibility
  },
  promise: <T>(
    promise: Promise<T>,
    msgs: {
      loading: string
      success: string | ((data: T) => string)
      error: string | ((error: any) => string)
    }
  ) => {
    globalToastInstance?.showToast(msgs.loading, 'info')

    return promise
      .then((data) => {
        const successMsg = typeof msgs.success === 'function' ? msgs.success(data) : msgs.success
        globalToastInstance?.showToast(successMsg, 'success')
        return data
      })
      .catch((error) => {
        const errorMsg = typeof msgs.error === 'function' ? msgs.error(error) : msgs.error
        globalToastInstance?.showToast(errorMsg, 'error')
        throw error
      })
  },
}
